import styled from 'styled-components';

export const List = styled.ul`
  display: flex;
  width: 100%;
  padding-top: 24px;
  margin-bottom: 40px;
  list-style: none;
`;